import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom'
import { I18nextProvider } from 'react-i18next'
import { Provider } from 'react-redux'
import { QueryClientProvider, QueryClient } from 'react-query'
import { CookiesProvider } from 'react-cookie'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import store from './redux/store'
import * as serviceWorker from './serviceWorker'
import App from './App'
import i18n from './i18n'
import { FeathersProvider } from './services/feathers'
import { initAmplitude } from './services/amplitude'

import 'antd/dist/antd.css'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import { toastOptions } from './utils/utils'

const queryClient = new QueryClient()

Sentry.init({
  dsn: 'https://397431f265b048d4a81d5f55cc4da54a@o435752.ingest.sentry.io/5397267',
  environment: process.env.REACT_APP_ENV || 'development',
})

initAmplitude()

const rootElement = document.getElementById('root')

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <FeathersProvider>
        <QueryClientProvider client={queryClient}>
          <I18nextProvider i18n={i18n}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </I18nextProvider>
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </QueryClientProvider>
      </FeathersProvider>
    </Provider>
    <Toaster toastOptions={toastOptions} />
  </CookiesProvider>,
  rootElement,
)

if (window.Cypress) {
  window.store = store
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
